import { FiscalNaturezaOp } from './../../model/fiscal/fiscalNaturezaOp';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})
@AutoRegisterService()
export class FiscalNaturezaOpService extends GenericService<FiscalNaturezaOp> {
  constructor(http: HttpClient) {
    super(http);
    super.initResource("fiscalnaturezaop")
  }
}
